/**
 * Created by razial on 21.05.2026.
 */

class KingsCupTableRowView {
    constructor(row, options) {
        // eslint-disable-next-line no-constructor-return
        return Prefab.instantiate(bundles.kingscup_window.jsons.kingscup_table_row_prefab_json, { args: [row, options] });
    }
}

KingsCupLogic.ROW_VIEWS["KingsCupTableRowView"] = KingsCupTableRowView;
